<template lang="pug">
    div
        div(
            class="or-mobile-header bg-white text-black relative p-3"
            :class="$storyblok.isEditing && $sitewideData.isNavbarPreview ? '' : 'z-30'"
        )
            div(class="flex justify-center items-center")
                button(
                    data-testid="mobileMenu"
                    v-if="!isSimpleMode"
                    class="xs:mr-6"
                    :class="{'z-[70]': $storyblok.isEditing && $sitewideData.isNavbarPreview}"
                )
                    Hamburger(
                        @click="$uiEvents.$emit('openMobileMenu')"
                        class="fill-current cursor-pointer h-8 w-8"
                    )
                div(class="flex-auto" :class="{'px-3 mx-auto': !isSimpleMode, 'mr-auto': isSimpleMode}" style="max-width: 210px;")
                    nuxt-link(:to="{ name: 'home' }")
                        Logo

                div(class="flex justify-end")
                    a(
                        :href="'tel:' + $config.runtime.theme.phoneNumbers.general"
                        data-track="phone-icon"
                        class="phone-link text-current block w-6 h-6"
                    )
                        component(
                            :is="iconComponent"
                            aria-label="phone"
                            class="or-header-item-icon w-6 h-6 fill-current"
                        )

                    BadgeContainer(
                        v-if="!isSimpleMode"
                        :simple="true"
                        class="ml-2"
                    )

            SearchBar(
                v-if="!isSimpleMode"
                class="pt-3"
            )

</template>

<script>
import Logo from '@/components/logo'
import Hamburger from '@/assets/common/hamburger?inline'
import SearchBar from './searchBar'
import BadgeContainer from './badgeContainer'

const PhoneIcon = () => import(/* webpackChunkName: "phone-icon" */ '@/assets/common/phone?inline')
const PhoneOutline = () =>
    import(/* webpackChunkName: "phoneOutline-icon" */ '@/assets/common/phoneOutline?inline')

export default {
    components: {
        Logo,
        SearchBar,
        BadgeContainer,
        Hamburger,
    },
    computed: {
        isSimpleMode() {
            return this.$store.state.isSimpleMode
        },
        iconComponent() {
            switch (this.$config.runtime.theme.header.options.support.icon) {
                case 'PHONE_OUTLINE':
                    return PhoneOutline
                case 'PHONE':
                default:
                    return PhoneIcon
            }
        },
    },
}
</script>
